__turbopack_context__.v({
  "className": "barlow_c1b94d2f-module__LhAfyq__className",
});
